import React from 'react'

export default function ErrorsPage() {
  return <div>ErrorsPage</div>
}
